<template>
  <router-view />
  <AppLoading />
  <AppFeedback />
</template>

<script setup>
import AppFeedback from '@/components/AppFeedback.vue';
import AppLoading from '@/components/AppLoading.vue';
</script>
